export const transactionTitles = {
  "transfer-sent": "Transferencia Enviada",
  "transfer-received": "Transferencia Recibida",
  withdrawal: "Retiro",
  deposit: "Depósito",
  "parley-rebate": "Parley 10% Cashback",
  "morning-promotion-award": "Promoción Depósito Matutina",
  "betby-bet": "Betby - Apuesta Perdida",
  "betby-win": "Betby - Apuesta Ganada",
  "betby-refund": "Betby - Apuesta Reembolso",
  "pixmove-bet": "Pixmove - Apuesta Perdida",
  "pixmove-win": "Pixmove - Apuesta Ganada",
  "pixmove-rollback": "Pixmove - Apuesta Reembolso",
  "pragmatic-bet": "Pragmatic - Apuesta Perdida",
  "pragmatic-win": "Pragmatic - Apuesta Ganada",
  "pragmatic-refund": "Pragmatic - Apuesta Reembolso",
  "hacksaw-rollback": "Hacksaw - Apuesta Reembolso",
  "hacksaw-win": "Hacksaw - Apuesta Ganada",
  "hacksaw-bet": "Hacksaw - Apuesta Perdida",
  "kaga-win": "Kaga - Apuesta Ganada",
  "kaga-bet": "Kaga - Apuesta Perdida",
  "gamingcorps-bet": "Gamingcorps - Apuesta Perdida",
  "gamingcorps-win": "Gamingcorps - Apuesta Ganada",
  "gamingcorps-refund": "Gamingcorps - Apuesta Reembolso",
  "bgaming-lost": "BGaming - Apuesta Perdida",
  "bgaming-win": "BGaming - Apuesta Ganada",
  "bgaming-bet": "BGaming - Apuesta Perdida",
  "bgaming-refund": "BGaming - Apuesta Reembolso",
  "upgaming-bet": "Upgaming - Apuesta Perdida",
  "upgaming-win": "Upgaming - Apuesta Ganada",
  "upgaming-lost": "Upgaming - Apuesta Perdida",
  "upgaming-refund": "Upgaming - Apuesta Reembolso",
  "pragmatic-adjustment": "Pragmatic - Adjustment",
  "lottery-ticket-purchase": "Lotería Ticket Comprado",
  "lottery-winnings": "Lotería Ganancia",
};
